"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var treeDataUtil_1 = require("@features/ItemCommon/components/common/SelectTree/treeDataUtil");
function Tree(_a) {
    var categories = _a.categories, tempCategory = _a.tempCategory, setTempCategory = _a.setTempCategory;
    var sortedCategories = (0, treeDataUtil_1.sortCategories)(categories);
    return (react_1.default.createElement(react_1.default.Fragment, null, sortedCategories &&
        Array.isArray(sortedCategories) &&
        sortedCategories.map(function (category) {
            return (react_1.default.createElement(SubTree, { key: "cat".concat(category.id), category: category, tempCategory: tempCategory, setTempCategory: setTempCategory }));
        })));
}
exports.Tree = Tree;
function SubTree(_a) {
    var category = _a.category, tempCategory = _a.tempCategory, setTempCategory = _a.setTempCategory;
    var _b = __read(react_1.default.useState((0, treeDataUtil_1.isPartOfChildrens)(category, tempCategory)), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    var sortedSubCat = category.subCategories && Array.isArray(category.subCategories) && (0, treeDataUtil_1.sortCategories)(category.subCategories);
    return (react_1.default.createElement("div", { className: "tree" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)({
                categoryName: true,
                selected: tempCategory.categoryId === category.categoryId,
            }), onClick: function () {
                if (category.subCategories) {
                    setIsExpanded(!isExpanded);
                }
                else {
                    setTempCategory(category);
                }
            } },
            category.subCategories && !isExpanded && react_1.default.createElement("i", { className: "implioicons-arrow-right" }),
            category.subCategories && isExpanded && react_1.default.createElement("i", { className: "implioicons-arrow-down" }),
            !category.subCategories && react_1.default.createElement("i", { className: "implioicons-dash" }),
            category.name),
        react_1.default.createElement("div", null, sortedSubCat && isExpanded && (react_1.default.createElement(Tree, { categories: sortedSubCat, tempCategory: tempCategory, setTempCategory: setTempCategory })))));
}
